import React from "react";
import { useNavigate } from "react-router-dom";

const ProfileUnavailableBanner = ({
    title = "Profile Unavailable",
    message = "This profile is not available right now.",
    hint = "You'll be able to View Profile once player is back.",
    showBackButton = true,
}) => {
    const navigate = useNavigate();

    return (
        <div style={styles.page}>
            {/* Top bar */}
            <div style={styles.topBar}>
                <div style={styles.brand}>
                    {/* Logo backing so white logo stays visible */}
                    <div style={styles.logoWrap}>
                        <img
                            src="/images/VSN-Icon-White-Cropped.png"
                            alt="VSN"
                            style={styles.logo}
                        />
                    </div>
                    <span style={styles.brandText}>VSN</span>
                </div>

                {/* Hamburger icon */}
                <div style={styles.menu} aria-label="menu">
                    <span style={styles.menuLine} />
                    <span style={styles.menuLine} />
                    <span style={styles.menuLine} />
                </div>
            </div>

            {/* Divider */}
            <div style={styles.divider} />

            {/* Center content */}
            <div style={styles.center}>
                <h1 style={styles.title}>{title}</h1>
                <p style={styles.message}>{message}</p>
                <p style={styles.hint}>{hint}</p>

                {showBackButton && (
                    <button
                        style={styles.button}
                        onClick={() => navigate(-1)}
                        onMouseDown={(e) => e.currentTarget.style.transform = "scale(0.98)"}
                        onMouseUp={(e) => e.currentTarget.style.transform = "scale(1)"}
                    >
                        Go Back
                    </button>
                )}
            </div>
        </div>
    );
};

const styles = {
    page: {
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#000",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
    },
    topBar: {
        height: "72px",
        padding: "0 28px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    brand: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
    },
    logoWrap: {
        width: "40px",
        height: "40px",
        backgroundColor: "#000",
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 0 18px rgba(255, 221, 0, 0.18)",
        border: "1px solid rgba(255, 221, 0, 0.18)",
    },
    logo: {
        width: "28px",
        height: "28px",
        objectFit: "contain",
        display: "block",
    },
    brandText: {
        fontWeight: 800,
        letterSpacing: "0.08em",
        color: "#fff",
        fontSize: "18px",
    },
    menu: {
        width: "44px",
        height: "44px",
        borderRadius: "12px",
        border: "1px solid rgba(255, 221, 0, 0.18)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "6px",
        padding: "0 12px",
    },
    menuLine: {
        height: "2px",
        width: "100%",
        backgroundColor: "#ffdd00",
        borderRadius: "2px",
    },
    divider: {
        height: "1px",
        width: "100%",
        backgroundColor: "rgba(255,255,255,0.08)",
    },
    center: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "28px",
        textAlign: "center",
    },
    title: {
        color: "#ffdd00",
        fontSize: "clamp(28px, 5vw, 56px)",
        fontWeight: 900,
        margin: "0 0 10px 0",
    },
    message: {
        fontSize: "clamp(14px, 2vw, 20px)",
        margin: "0 0 8px 0",
        opacity: 0.95,
    },
    hint: {
        fontSize: "clamp(12px, 1.6vw, 16px)",
        margin: "0 0 18px 0",
        opacity: 0.7,
        maxWidth: "680px",
        lineHeight: 1.6,
    },
    button: {
        marginTop: "6px",
        backgroundColor: "#ffdd00",
        color: "#000",
        border: "none",
        borderRadius: "10px",
        padding: "12px 18px",
        fontWeight: 900,
        cursor: "pointer",
        boxShadow: "0 0 22px rgba(255, 221, 0, 0.25)",
        transition: "transform 0.08s ease-in-out",
    },
};

export default ProfileUnavailableBanner;